import script from "./RelatedLessons.vue?vue&type=script&setup=true&lang=js"
export * from "./RelatedLessons.vue?vue&type=script&setup=true&lang=js"

import "./RelatedLessons.vue?vue&type=style&index=0&id=cafe48ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cafe48ae"]])

export default __exports__